import { render, staticRenderFns } from "./FormSummary.vue?vue&type=template&id=422d7db0&scoped=true"
import script from "./FormSummary.vue?vue&type=script&lang=js"
export * from "./FormSummary.vue?vue&type=script&lang=js"
import style0 from "./FormSummary.vue?vue&type=style&index=0&id=422d7db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d7db0",
  null
  
)

export default component.exports